import { ITrainerGetResponseOK } from '@ifit/gateway-trainer-store';

const getTrainerName = (trainer: ITrainerGetResponseOK): string =>
  trainer.firstName ? `${trainer.firstName} ${trainer.lastName}` : '';

export default getTrainerName;
